import React from 'react'
import "./stylesheets/Footer.css";
import { BrowserView, MobileView } from 'react-device-detect';
import  Facebook from "./images/Facebook.png";
import  Instagram from "./images/Instagram.png";
import  Youtube from "./images/YouTube.png";
import  Linkedin from "./images/linkedin_.png";

window.onscroll = function() {
    var footer = this.document.getElementById("myFooter");
    if (window.scrollY > 200) {
        footer.classList.add("fixed-footer");
    } else {
        footer.classList.remove("fixed-footer")
    }
}
export const Footer = () => {
  return (
    <>
    <BrowserView>
     <footer id="myFooter" className= "hidden">
        <span id="siteseal"><script async type="text/javascript" src="https://seal.godaddy.com/getSealBasic?sealID=B6NKe0LmdKaluCaVhzbFUdSMEvAr22FTG4jfQ12nAKORpOD54KGTaRLCIIo0"></script></span>
        <img className="socials" src= {Facebook} />
        <img className="socials" src= {Instagram} />
        <img className="socials" src= {Youtube} />
        <img className="socials" src= {Linkedin} />
        <p>This site was designed and coded by Arrival Design. All rights reserved.</p>
    </footer>
    </BrowserView>
    <MobileView>
    <footer id="myFooter" className= "mobileFooter">
        <span id="siteseal"><script async type="text/javascript" src="https://seal.godaddy.com/getSealBasic?sealID=B6NKe0LmdKaluCaVhzbFUdSMEvAr22FTG4jfQ12nAKORpOD54KGTaRLCIIo0"></script></span>
        <img className="socials" src= {Facebook} />
        <img className="socials" src= {Instagram} />
        <img className="socials" src= {Youtube} />
        <img className="socials" src= {Linkedin} />
        <p>This site was designed and coded by Arrival Design. All rights reserved.</p>
    </footer> 
    </MobileView>
    </>
  )
}
